<template>
  <div class="auth">
    <main class="auth__container container">
      <header class="auth__header col--4">
        <a class="auth__logo" href="#">
          <img src="@/assets/logo.png" srcset="@/assets/logo@2x.png 2x, @/assets/logo@3x.png 3x">
        </a>
      </header>

      <RouterView class="auth__view col--4" />

      <footer class="auth__footer col--4">
        <RouterLink
          :to="meta.to"
          class="auth__link"
          >
          {{ meta.cta }}

          <span v-text="meta.label"></span>
        </RouterLink>
      </footer>
    </main>
  </div>
</template>

<script>
  export default {
    computed: {
      meta () {
        return this.$route.meta || {};
      },
    },
  };
</script>

<style lang="scss">
  .auth {
    display: flex;
    min-height: 100vh;
    align-items: center;
    background-size: cover;
    background-position: center;
    background-color: #14162f;
    background-attachment: fixed;
    background-image: url('~@/assets/auth-background.jpg');

    &__container {
      display: flex;
      padding: 64px 0;
      align-items: flex-end;
      flex-direction: column;
    }

    &__header {
      text-align: center;
      margin-bottom: 64px;
    }

    &__action {
      width: 100%;
      color: #FFF;
      padding: 12px;
      margin-top: 16px;
      border-radius: 4px;
      letter-spacing: 0.32px;
      background-color: #3e388b;

      &:hover {
        background-color: #322c76;
      }
    }

    &__footer {
      margin-top: 64px;
      text-align: center;
    }

    &__link {
      color: #b2b8c5;
      line-height: 1.56;

      span {
        color: #FFF;
        display: block;
        font-weight: 500;
      }
    }
  }
</style>
